module.exports = __webpack_public_path__ + "media/western-osprey-3.c7c781d1.mp3";